import type { NavigationGuard } from 'vue-router';

import { getToken } from 'src/logic/services/token.service';

import { useAuthStore } from '../stores/auth.store';

export const alreadyLoggedGuard: NavigationGuard = async () => {
  const { getUser, getOnboardingStatus } = useAuthStore();

  if (getToken()) {
    const isTokenValid = await getUser();
    if (isTokenValid) {
      return { name: 'home' };
    }
  }
};
